import { CommandPresignUpload } from "./commands/cmdPresignUpload";
import { CommandListFiles } from "./commands/cmdListFiles";
import { CommandValidateFile } from "./commands/cmdValidateFile";
import { CommandRunFile } from "./commands/cmdRunFile";
import { CommandMarkUploadFailed } from "./commands/cmdMarkUploadFailed";
import { CommandDownloadFile } from "./commands/cmdDownloadFile";
import { CommandVerifyDownload } from "./commands/cmdVerifyDownload";
import { CommandPreviewRunVersions } from "./commands/cmdPreviewRunVersions";
import { CommandProcessPendingFiles } from "./commands/cmdProcessPendingFiles";
import { CommandReprocessAllFiles } from "./commands/cmdReprocessAllFiles";
import { CommandDiscardFile } from "./commands/cmdDiscardFile";
import { CommandGetDefinitionBilledPeriods } from "./commands/cmdGetDefinitionBilledPeriods";
import { CommandGetDefinitionFileHistory } from "./commands/cmdGetDefinitionFileHistory";

export class IngestFileService {
  async presignUpload(
    organizationId: number,
    filename: string,
    contentType?: string,
    ingestDefinitionId?: number,
  ) {
    return new CommandPresignUpload().run(organizationId, filename, contentType, ingestDefinitionId);
  }

  async processPendingFiles(definitionId: number) {
    return new CommandProcessPendingFiles().run(definitionId);
  }

  async reprocessAllFiles(definitionId: number, override?: { reason: string }) {
    return new CommandReprocessAllFiles().run(definitionId, override);
  }

  async getDefinitionBilledPeriods(definitionId: number) {
    return new CommandGetDefinitionBilledPeriods().run(definitionId);
  }

  async getDefinitionFileHistory(definitionId: number) {
    return new CommandGetDefinitionFileHistory().run(definitionId);
  }

  async discardFile(fileId: number) {
    return new CommandDiscardFile().run(fileId);
  }

  async listFiles(organizationId: number, ingestDefinitionId?: number) {
    return new CommandListFiles().run(organizationId, ingestDefinitionId);
  }

  async validateFile(fileId: number, definitionId: number, populationSegmentName?: string) {
    return new CommandValidateFile().run(fileId, definitionId, populationSegmentName);
  }

  async runFile(fileId: number) {
    return new CommandRunFile().run(fileId);
  }

  async markUploadFailed(fileId: number, message: string) {
    return new CommandMarkUploadFailed().run(fileId, message);
  }

  async downloadFile(fileId: number) {
    return new CommandDownloadFile().run(fileId);
  }

  async verifyDownload(fileId: number) {
    return new CommandVerifyDownload().run(fileId);
  }

  async previewVersions(runId: number) {
    return new CommandPreviewRunVersions().run(runId);
  }
}
